export default __webpack_public_path__ + "static/media/data-logo-white.png";